// Returns marker label to be displayed as title of chapter
// shorten marker title if over 60 characters
export const getMarkerTitle = (marker) => {
  const markerTitle =
    marker.label.length > 60
      ? marker.label.substring(0, 60) + '...'
      : marker.label;

  return markerTitle;
};

// Returns Page Label to display in title as pageNumber
export const getPageLabel = (marker) => {
  if (marker.isTopLevelMarker && marker.pageLabel) {
    return marker.pageLabel;
  }

  return null;
};

// Returns which level the marker is at. TopLevelMarker is 1 and it's child is 2 and so on
export const getDepth = (marker) => {
  let count = 1;
  if (marker?.parent) {
    count = 1 + getDepth(marker?.parent);
  }
  return count;
};
